import { PageTemplate } from '@/common/PageWrapper';
import { Link } from 'react-router';

export function HomePage() {
  return (
    <PageTemplate>
      <div className="px-20 py-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
          <h1 className="font-bold text-[24px] md:text-5xl leading-tight mb-2 md:mb-0">
            <span className="px-2">Belajar Kapan Saja dan Di</span>
            <br />
            <span className="px-2">Mana Saja</span>
          </h1>
          <p className="font-semibold text-[16px] md:font-normal md:text-2xl text-gray-600 max-w-2xl">
            Ikuti pelatihan online bersama para profesional di bidangnya untuk mengasah kemampuan,
            memperluas wawasan, serta membangun keterampilan praktis yang relevan dengan kebutuhan
            industri saat ini dan masa depan.
          </p>
        </div>

        <hr className="my-8" />

        {/* Module Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Modul 1 */}
          <Link to="/courseintro">
            <div
              className="bg-white rounded-xl border border-gray-300 overflow-hidden shadow-sm flex flex-col hover:shadow-md transition-shadow duration-200"
            >
              <img
                src="https://images.unsplash.com/photo-1556740738-b6a63e27c4df?auto=format&fit=crop&w=800&q=80"
                alt="E-Commerce"
                className="h-48 w-full object-cover"
              />
              <div className="p-5 flex-1 flex flex-col">
                <div className="font-semibold text-[16px] md:text-xl mb-2">
                  E-Commerce
                </div>
                <div className="text-gray-500 text-[16px] mt-auto">
                  Pemula - 4 Modul Pembelajaran
                </div>
              </div>
            </div></Link>

          <Link to="/courseintro">
            {/* Modul 2 */}
            <div
              className="bg-white rounded-xl border border-gray-300 overflow-hidden shadow-sm flex flex-col hover:shadow-md transition-shadow duration-200"
            >
              <img
                src="https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=600&q=80"
                alt="UI/UX Design"
                className="h-48 w-full object-cover"
              />
              <div className="p-5 flex-1 flex flex-col">
                <div className="font-semibold text-[16px] md:text-xl mb-2">UI/UX Design</div>
                <div className="text-gray-500 text-[16px] mt-auto">
                  Pemula - 4 Modul Pembelajaran
                </div>
              </div>
            </div></Link>

          {/* Modul 3 */}

          <Link to="/courseintro">
            <div
              className="bg-white rounded-xl border border-gray-300 overflow-hidden shadow-sm flex flex-col hover:shadow-md transition-shadow duration-200"
            >
              <img
                src="https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=600&q=80"
                alt="Introduction to Social Media Marketing"
                className="h-48 w-full object-cover"
              />
              <div className="p-5 flex-1 flex flex-col">
                <div className="font-semibold text-[16px] md:text-xl mb-2">
                  Introduction to Social Media Marketing
                </div>
                <div className="text-gray-500 text-[16px] mt-auto">
                  Pemula - 4 Modul Pembelajaran
                </div>
              </div>
            </div></Link>

          {/* Modul 4 */}
          <Link to="/courseintro">
            <div
              className="bg-white rounded-xl border border-gray-300 overflow-hidden shadow-sm flex flex-col hover:shadow-md transition-shadow duration-200"
            >
              <img
                src="https://images.unsplash.com/photo-1586880244406-556ebe35f282?auto=format&fit=crop&w=800&q=80"
                alt="React Dasar"
                className="h-48 w-full object-cover"
              />
              <div className="p-5 flex-1 flex flex-col">
                <div className="font-semibold text-[16px] md:text-xl mb-2">Digital Marketing</div>
                <div className="text-gray-500 text-[16px] mt-auto">
                  Pemula - 4 Modul Pembelajaran
                </div>
              </div>
            </div></Link>
        </div>
      </div>
    </PageTemplate>
  );
}
